module.exports = __webpack_public_path__ + "img/logo_wordmark.54e8e6bb.svg";